import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {Form} from "../../../shared/interface/form";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../shared/services/auth.service";
import {takeUntil} from "rxjs/operators";
import {FormAddService} from "../../../shared/services/form-add.service";
import {HttpErrorResponse} from "@angular/common/http";
import {AngularEditorConfig} from "@kolkov/angular-editor";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {FormRow} from "../../../shared/interface/form-row";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {UserService} from "../../../shared/services/user.service";
import {User} from "../../../shared/interface/user";
import {er} from "@fullcalendar/core/internal-common";

@Component({
  selector: 'app-dynamic-forms-details-view',
  templateUrl: './dynamic-forms-details-view.component.html',
  styleUrls: ['./dynamic-forms-details-view.component.scss']
})
export class DynamicFormsDetailsViewComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() dynamicForm: Observable<Form>;
  @Output() modifyClicked = new EventEmitter<any>();
  dynamicFormObject?: Form;
  userPermissions: ReplaySubject<UserPermissions>;
  userPermissionss: UserPermissions;
  contentEmailControl: FormControl;
  contentEmailToReturnToSenderControl: FormControl;
  permissionUserControl: FormControl;
  users: User[] = []; // Store the fetched user data
  userIds: string[];
  usernames: string[];
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  mailSend: boolean;
  ownerSend: boolean;
  serviceTime: boolean;
  templateForm: FormGroup;

  editorConfig: AngularEditorConfig = {
    editable: false,
    spellcheck: true,
    height: 'auto',
    minHeight: '300px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Wprowadź treść email..',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      {class: 'arial', name: 'Arial'},
      {class: 'times-new-roman', name: 'Times New Roman'},
      {class: 'calibri', name: 'Calibri'},
      {class: 'comic-sans-ms', name: 'Comic Sans MS'}
    ],
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [],
      [
        'insertImage',
        'insertVideo',
      ]
    ]
  };
  constructor(
    private snack: MatSnackBar,
    private auth: AuthService,
    private formService: FormAddService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private router: Router,
    private userService: UserService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.templateForm = this.fb.group({
      contentEmail: this.contentEmailControl = fb.control('', [Validators.required]),
      contentEmailToReturnToSender: this.contentEmailToReturnToSenderControl = fb.control('', [Validators.required]),
      permissionUserControl: this.permissionUserControl = fb.control(''),
    });
    this.auth.getUserPermissions()
      .subscribe((userPermissions: UserPermissions) => {
        this.userPermissionss = userPermissions;
      });
  }


  ngOnInit(): void {
    this.dynamicForm
      .pipe(takeUntil(this.destroyed$))
      .subscribe((dynamicForm: Form) => {
        this.dynamicFormObject = dynamicForm;
        this.mailSend = this.dynamicFormObject?.emailSend;
        this.ownerSend = this.dynamicFormObject?.emailSendToAssignStructure;
        this.serviceTime = this.dynamicFormObject?.serviceTime > 0;
        this.contentEmailControl.setValue(dynamicForm?.contentEmail);
        this.contentEmailToReturnToSenderControl.setValue(dynamicForm?.contentEmailToReturnToSender);
        this.permissionUserControl.setValue(dynamicForm?.permissionUser);

        this.userIds = dynamicForm?.permissionUser;
        this.fetchUsersSequentially();
      });
  }

  ngAfterViewInit(): void {
    // this.contentEmailControl.disable();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  copyMessage(val: string): void {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.snack.open('Skopiowano do schowka', '', {duration: 2000});

  }

  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć formularz?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.formService.deleteFormDictionary(this.dynamicFormObject.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto formularz', '', {duration: 2000});
            this.router.navigate(['/formularze']);
          });
      }
    });
  }
  async fetchUsersSequentially() {
     if (this.userPermissionss.user.read)
    {
      try {
        this.users = await this.userService.getUsersSequentially(this.userIds);
        this.usernames = this.users.map(user => user.username);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    }
  }
}
